import {Link} from 'react-router-dom';
import {Suspense, useEffect, useState} from "react";
import Button from "./component-assets/Button.jsx";
import {
    actionAppearance, checkAll, showModal, formFail, handleSubmitActions,
    paginateData, sortFunc, formSuccess, iAmHigherAuthority, callActionModal, isBannerPresent, headerFilterFunc,
    searchFunc
} from "../libs.jsx";
import ApiRequester from "./ApiRequester.jsx";
import TableBody from "./component-assets/TableBody.jsx";
import TableHeaders from "./component-assets/TableHeaders.jsx";
import {CSVLink} from "react-csv";
import {Pagination} from "react-bootstrap";
import PaginationItems from "./component-assets/PaginationItems.jsx";
import Header from "./Header.jsx";
import Footer from "./Footer.jsx";
import BulkActionModal from "./component-assets/BulkActionModal.jsx";
import PerPageModal from "./component-assets/PerPageModal.jsx";
import {toast, ToastContainer} from "react-toastify";
import CampusDropDown from "./component-assets/CampusDropDown.jsx";
import Navigation from "./Navigation.jsx";
import TableSkeleton from "./component-assets/skeletons/TableSkeleton.jsx";
import { getSession, setSession, getActiveVendorIdList } from "../services/session";

const Devices = (props) => {
    let dData, bData, headerData, csvHeaders;

    dData = getSession();

    if (dData?.campusData[dData?.acnt.toString()]?.is_cloud){
        headerData = [
            {label: "Name", key: "device_name", align: "left", filtered: true, rowSpan: true, row: 1, rows: 2,
                link: {enabled: true, type: "conditional", conditionKey: "manufacture_id",
                    condition: {"1": {linkto: "/community/devices/1", linkkey: "device_id"},
                                "4": {linkto: "/community/devices/4", linkkey: "device_id"}}}},
            {label: "Description", key: "descriptions", align: "left", filtered: true, rowSpan: true, row: 1, rows: 2},
            {label: "Model", key: "inovonics_model_name", align: "center", filtered: true, rowSpan: true, row: 1, rows: 2},
            {label: "Serial Number", key: "manufacture_uuid", align: "center", filtered: true, rowSpan: true, row: 1, rows: 2},
            {label: "Residents", key: "residents", align: "center", filtered: true, filterKey: "resident_name", rowSpan: true, row: 1, rows: 2,
                link: {enabled: true, linkto: "/profiles/resident", linkkey: "resident_id", type: "obj", displayKey: ["resident_name"]}},
            {label: "Area", key: "area_name", align: "center", filtered: true, rowSpan: true, row: 1, rows: 2,
                link: {enabled: true, type: "standard", linkto: "/profiles/area", linkkey: "area_id"}},
            {label: "Device Health", key: "", row: 1, colSpan: true, cols: 3, bgColor: "#0080c5", sorts: false},
            {label: `Battery`, key: "low_battery", align: "center", type: "iconswap", dataType: "number", row: 2,
                filtered: true, filterKey: "low_battery_text",
                condition: [
                    {type: "equal", minvalue: 1, maxvalue: 1, icon: "battery_error",
                        iconType: "google-symbols", color: "#BB271A", title: "Battery Low"},
                    {type: "equal", minvalue: 0, maxvalue: 0, icon: "battery_status_good",
                        iconType: "google-symbols", color: "#1abb27", title: "Battery Ok"}
                ]},
            {label: `Tamper`, key: "tamper", align: "center", type: "iconswap", dataType: "number", row: 2,
                filtered: true, filterKey: "tamper_text",
                condition: [
                    {type: "equal", minvalue: 1, maxvalue: 1, icon: "gpp_maybe",
                        iconType: "google-symbols", color: "#BB271A", title: "Device Open"},
                    {type: "equal", minvalue: 0, maxvalue: 0, icon: "shield_lock",
                        iconType: "google-symbols", color: "#1abb27", title: "Device Secured"}
                ]},
            {label: `Offline Status`, key: "offline", align: "center", type: "iconswap", dataType: "number",
                row: 2, filtered: true, filterKey: "offline_text",
                condition: [
                    {type: "equal", minvalue: 1, maxvalue: 1, icon: "signal_disconnected",
                        iconType: "google-symbols", color: "#BB271A", title: "Device Offline"},
                    {type: "equal", minvalue: 0, maxvalue: 0, icon: "bigtop_updates",
                        iconType: "google-symbols", color: "#1abb27", title: "Device Online"}
                ]},
            {label: "Last Alarm", key: "last_alarm", align: "center", type: "datetime", rowSpan: true, row: 1, rows: 2},
            {label: "Last Active", key: "last_active", align: "center", type: "datetime", rowSpan: true, row: 1, rows: 2},
            {label: "Assigned", key: "is_active", align: "center",  filtered: true, filterKey: "assigned", type: "bool",
                t: "Yes", f: "No", rowSpan: true, row: 1, rows: 2}
        ];
    }else{
        headerData = [
            {label: "Name", key: "device_name", align: "left", filtered: true,
                link: {enabled: true, type: "conditional", conditionKey: "manufacture_id",
                    condition: {"1": {linkto: "/community/devices/1", linkkey: "device_id"},
                                "4": {linkto: "/community/devices/4", linkkey: "device_id"}}}},
            {label: "Description", key: "descriptions", align: "left", filtered: true},
            {label: "Model", key: "inovonics_model_name", align: "center", filtered: true},
            {label: "Serial Number", key: "manufacture_uuid", align: "center", filtered: true},
            {label: "Residents", key: "residents", align: "center", filtered: true, filterKey: "resident_name",
                link: {enabled: true, linkto: "/profiles/resident", linkkey: "resident_id", type: "obj", displayKey: ["resident_name"]}},
            {label: "Area", key: "area_name", align: "left", filtered: true,
                link: {enabled: true, type: "standard", linkto: "/profiles/area", linkkey: "area_id"}},
            {label: "Last Alarm", key: "last_alarm", align: "center", type: "datetime"},
            {label: "Last Active", key: "last_active", align: "center", type: "datetime"},
            {label: "Active Status", key: "is_active", align: "center",  filtered: true, type: "bool", t: "Yes", f: "No"}
        ];
    }

    if (dData?.campusData[dData?.acnt.toString()]?.is_cloud){
        csvHeaders = [
            {label: "Name", key: "device_name"},
            {label: "Description", key: "descriptions"},
            {label: "Device Model", key: "inovonics_model_name"},
            {label: "Serial Number", key: "manufacture_uuid"},
            {label: "Resident Name", key: "resident_name"},
            {label: "Area Name", key: "area_name"},
            {label: "Category", key: "device_category"},
            {label: "Last Alarm", key: "last_alarm"},
            {label: "Last Active", key: "last_active"},
            {label: "Temperature", key: "current_temperature"},
            {label: "Humidity", key: "current_humidity"},
            {label: "Battery", key: "current_battery"},
            {label: "Environmental Report Time", key: "env_create_time"},
            {label: "Active Status", key: "is_active"}
        ];
    }else{
        csvHeaders = [
            {label: "Name", key: "device_name"},
            {label: "Description", key: "descriptions"},
            {label: "Device Model", key: "inovonics_model_name"},
            {label: "Serial Number", key: "manufacture_uuid"},
            {label: "Resident Name", key: "resident_name"},
            {label: "Area Name", key: "area_name"},
            {label: "Category", key: "device_category"},
            {label: "Last Alarm", key: "last_alarm"},
            {label: "Last Active", key: "last_active"},
            {label: "Active Status", key: "is_active"}
        ];
    }

    if (iAmHigherAuthority(99, dData?.role_weight)){
        csvHeaders.splice(0, 0, {label: "Device ID", key: "device_id"});
    }

    // Permission Variables
    const [editRights, setEditRights] = useState(iAmHigherAuthority(80, dData?.role_weight));
    const [deleteRights, setDeleteRights] = useState(iAmHigherAuthority(80, dData?.role_weight));
    const [originLoaded, setOriginLoaded] = useState(false);
    const [pageLoaded, setPageLoaded] = useState(false);
    const [read, setRead] = useState(true);
    const [skeleton, setSkeleton] = useState(<TableSkeleton />);
    // Main Table Variables
    const [dataOrigin, setDataOrigin] = useState([]);
    const [transOrigin, setTransOrigin] = useState([]);
    const [activeData, setActiveData] = useState([]);
    const [tableRows, setTableRows] = useState([]);
    const [loadState, setLoadState] = useState("inovonics");
    const [count, setCount] = useState(0);
    const [campusId, setCampusId] = useState(dData.acnt);
    const [storePage, setStorePage] = useState(1);
    const [page, setPage] = useState(1);
    const [hideUnassigned, setHideUnassigned] = useState(false);
    const [perPage, setPerPage] = useState(dData.perPage);
    const [tmpPerPage, setTmpPerPage] = useState(dData.perPage);
    const [dContent, setDContent] = useState([]);
    const [deviceIdList, setDeviceIdList] = useState([]);
    const [search, setSearch] = useState("");
    const [headerFilters, setHeaderFilters] = useState([]);
    const [sorter, setSorter] = useState({
        sortColumn: "descriptions",
        sortOrder: "asc"
    });
    const [ppRules, setPRules] = useState({
        start: 0,
        end: 1,
        beginDot: false,
        endDot: false,
        pageMin: 1,
        pageMax: 1,
        max: 1
    });
    //Other Enact Once Variables
    const [csvLink, setLink] = useState({
        filename: "devices.csv",
        headers: [],
        data: []
    });
    const [csvButton, setCSVButton] = useState(
        <CSVLink {...csvLink} uFEFF={false}>
            <Button text={"Export"} icon={true} iconClass={"fe fe-download me-2"} class={"btn btn-primary ms-2 px-4 mt-1"}/>
        </CSVLink>);

    useEffect(() => {
        let interval = null;
        interval = setInterval(() => {
             setCount(count => count - 1);
        }, 1000);
        if (count <= 0){
            ApiRequester({reqEndpoint: "myfetch", payload: {device_filter: "",
                                device_category_filter: "1,2,3,6,7,8,9,10,11,12,15,16,17", campus_id: campusId}, "read-only": read,
                                procedure: "sp_dev_getInovonicsDevices", reqType: "stored"}).then(data => {
                    setDataOrigin(data);
                    setOriginLoaded(true);
            });
            setRead(true);
            setCount(count => 600);
        }
        return () => clearInterval(interval);
    }, [count]);

    useEffect(() => {
        let pRules = paginateData(activeData, page, perPage);
        setPRules(pRules);
        if (activeData.length > 0) {
            activeData.sort((a, b) => sortFunc(a, b, sorter.sortColumn, sorter.sortOrder));
        }
        setTableRows(<TableBody start={pRules.start} end={pRules.end} tableData={activeData} checkbox={editRights || deleteRights}
                                writeAccess={editRights || deleteRights} unk={"a-"}
                                actionAppearance={() => actionAppearance(pRules.start, pRules.end, ["disableBtn", "deleteBtn"])}
                                tableHeaders={headerData} editModal={() => {}} parentComponent={"Community"}
                                dData={dData} checkboxlist={deviceIdList} setCheckboxId={(value) => {setDeviceIdList(value)}}
                                checkidkey={"device_id"} />);
    }, [activeData, sorter, page, perPage, transOrigin, dataOrigin, deviceIdList]);

    useEffect(() => {
        setLink(prevState => {
            return {...prevState,
                headers: csvHeaders,
                data: dataOrigin}
        });
        setTransOrigin(dataOrigin.filter((item) => {return (!hideUnassigned || (hideUnassigned && item?.is_active))}));
    }, [dataOrigin, hideUnassigned]);

    useEffect(() => {
        setCSVButton(
            <CSVLink {...csvLink} uFEFF={false}>
                <Button text={"Export"} icon={true} iconClass={"fe fe-download me-2"} class={"btn btn-primary ms-2 px-4 mt-1"}/>
            </CSVLink>
        )
    }, [csvLink]);

    useEffect(() => {
        if (![originLoaded].includes(false)){
            setPageLoaded(true);
        }
    }, [originLoaded]);

    useEffect(() => {
        // Performs realtime search of data as location types.
        let tmpData, pRules, searchKeys;

        let filteredData = headerFilterFunc(transOrigin, headerFilters, headerData);

        searchKeys = ["device_name", "descriptions", "manufacture_uuid", "inovonics_model_name", "area_name", "resident_name"];
        tmpData = searchFunc(search, filteredData, searchKeys);

        pRules = paginateData(tmpData, page, perPage);
        if (search && page > pRules.pageMax){
            setPage(pRules.pageMax);
        }else if (!search){
            setPage(storePage);
        }
        setPRules(pRules);
        setActiveData(tmpData);
    }, [search, transOrigin, headerFilters]);

    function filterSubmit(){
        handleSubmitActions("filterSubmit", "loadFilterSubmit");
        setPerPage(tmpPerPage);
        setDeviceIdList([]);
        dData.perPage = tmpPerPage;
        setPage(1);
        setSession(dData);
        formSuccess("Page parameters stored to session.", "filterSubmit", "loadFilterSubmit", "cancelFilterBtn");
        setCount(0);
    }

    function disablePerform(submitBtn, loadBtn, closeId, start, end){
        let payload = [], oldPayload = [];
        if (editRights){
            handleSubmitActions(submitBtn, loadBtn);
            for (let i=0; i < dContent.length; i++){
                payload.push({device_id: dContent[i][0], is_active: false, resident_id: null, area_id: null,
                              modified_by: dData.user, vendor_ids: getActiveVendorIdList(),
                              });
                oldPayload.push({device_id: dContent[i][0], area_id: dContent[i][2], resident_id: dContent[i][1]});
            }
            ApiRequester({reqEndpoint: "mytransaction", TransType: "device_unassign", Payload: payload,
                                CampusId: campusId, User: dData.user, OldPayload: oldPayload,
                                ClientId: dData.sessionId}).then(data => {
                if (data[0]){
                    setRead(false);
                    setCount(0);
                    setDeviceIdList([]);
                    formSuccess("Devices marked inactive.", submitBtn, loadBtn, closeId);
                    document.getElementById("uCheckHead").checked = false;
                    checkAll(start, end);
                    actionAppearance(start, end, ["disableBtn", "deleteBtn"]);
                }
                else{
                    formFail(`Failed to delete with error: ${data[1]}`, submitBtn, loadBtn);
                }
            });
        }else{
            toast.warn("You do not have permissions to perform this action.");
        }
    }

    function deletePerform(submitBtn, loadBtn, closeId, start, end){
        let payload = [], oldPayload = [];
        if (deleteRights){
            handleSubmitActions(submitBtn, loadBtn);
            for (let i=0; i < dContent.length; i++){
                payload.push({device_id: dContent[i][0], modified_by: dData.user,
                              vendor_ids: getActiveVendorIdList(),
                              });
                oldPayload.push({device_id: dContent[i][0], area_id: dContent[i][2], resident_id: dContent[i][1]});
            }
            ApiRequester({reqEndpoint: "mytransaction", TransType: "device_delete", Payload: payload,
                                CampusId: campusId, User: dData.user, OldPayload: oldPayload,
                                ClientId: dData.sessionId}).then(data => {
                if (data[0]){
                    setRead(false);
                    setCount(0);
                    setDeviceIdList([]);
                    formSuccess("Devices deleted.", submitBtn, loadBtn, closeId);
                    document.getElementById("uCheckHead").checked = false;
                    checkAll(start, end);
                    actionAppearance(start, end, ["deleteBtn", "disableBtn"]);
                }
                else{
                    formFail(`Error during delete, error code: ${data[1]}`, submitBtn, loadBtn);
                }
            });
        }else{
            toast.warn("You do not have permissions to perform this action.");
        }
    }

    const tableHeaders = <TableHeaders checkbox={editRights || deleteRights} headerData={headerData} rowCnt={dData?.campusData[dData?.acnt.toString()]?.is_cloud ? 2 : 1}
                                       checkAll={() => checkAll(ppRules.start, ppRules.end, deviceIdList, setDeviceIdList)}
                                       writeAccess={editRights || deleteRights} sortOrder={sorter.sortOrder} originData={transOrigin} headerFiltersOn={true}
                                       sortColumn={sorter.sortColumn} sorter={sorter} setSorter={setSorter} checkboxlist={deviceIdList}
                                       actionAppearance={() => actionAppearance(ppRules.start, ppRules.end, ["deleteBtn"])}
                                       headerFilters={headerFilters} setHeaderFilters={setHeaderFilters} setPage={setPage} />

    const headerContent = (
        <div className={"d-flex justify-content-between"}>
            <div style={{minWidth: "360px"}}>
                {deleteRights && <Button text={"Delete"} type={"button"} class={"btn btn-danger ms-2 hide mt-1"}
                                     id={"deleteBtn"} icon={true} iconClass={"fe fe-trash-2 me-2"}
                                     onClick={() => callActionModal(ppRules.start, ppRules.end, activeData, ["device_name", "manufacture_uuid"],
                                         ["device_id", "resident_id", "area_id"], "", setDContent, "bulkdeletemodal", "deleteBulkModalContent",
                                         "Are you sure you wish to delete the following devices, this can not be undone?")} />}
                {editRights && <Button text={"Unassign"} type={"button"} class={"btn btn-danger ms-2 hide mt-1"}
                                     id={"disableBtn"} icon={true} iconClass={"fe fe-alert-octagon me-2"}
                                     onClick={() => callActionModal(ppRules.start, ppRules.end, activeData, ["device_name", "manufacture_uuid"],
                                         ["device_id", "resident_id", "area_id"], "", setDContent, "bulkdisablemodal", "disableBulkModalContent",
                                         "Are you sure you wish to disable the following records, this will deactivate them and remove them from their assigned area and resident?")} />}
                <div className={"form-outline d-inline-flex align-bottom ms-2"}>
                    <input type={"search"} id={"search1"} className={"form-control search-input mt-1"}
                         onKeyUp={(e) => setSearch(e.target.value)} />
                    <Button text={""} type={"button"} class={"btn btn-primary smooth-radius-left mt-1"} style={{height: "42px"}}
                            icon={true} iconClass={"fe fe-search"}/>
                </div>
                {csvButton}
                <div className={"d-block"}>
                    <div className={"form-check d-inline-block mt-3 float-end"}>
                        <input className={"form-check-input form-check-med"} id={"active-toggle"} name={"active-toggle"}
                               title={"Unassigned items are not monitored by the system and device health may not be accurate"}
                               type={"checkbox"} checked={hideUnassigned} onChange={(e) => {
                                   setHideUnassigned(e.target.checked);
                        }} />
                        <label className={"form-check-label"} htmlFor={"active-toggle"}
                               title={"Unassigned items are not monitored by the system and device health may not be accurate"}>
                            Hide Unassigned
                        </label>
                    </div>
                </div>
            </div>
            <CampusDropDown campusId={campusId} setCampusId={(item) => setCampusId(item)}
                            setCount={(item) => setCount(item)}
                            pageAction={() => {
                                setOriginLoaded(false);
                                setPageLoaded(false);
                            }}/>
        </div>
    );

    const footer = (
        <div>
            <Pagination>
                <PaginationItems setPage={setPage} page={page} beginDot={ppRules.beginDot}
                                 endDot={ppRules.endDot} pageMin={ppRules.pageMin} pageMax={ppRules.pageMax}
                                 max={ppRules.max}/>
            </Pagination>
            <Button class={"btn btn-secondary fs-5 ms-4"} text={perPage} onClick={() => showModal("filtermodal")}/>
        </div>
    );

    return (
        <>
            <Navigation />
            <div className={"main-content"}>
                <Header preTitle={"Community"} Title={"Devices"} content={headerContent}/>
                <div className={"container-fluid"}>
                    <ul className={"nav nav-tabs nav-overflow header-tabs"}>
                        <li className={"nav-item"}>
                            <Link to={"/community/devices"}>
                                <Button text={"Nurse Call"}
                                        class={loadState === "inovonics" ? "nav-link active" : "nav-link"}
                                        onClick={() => setLoadState("inovonics")}/>
                            </Link>
                        </li>
                        <li className={"nav-item"}>
                            <Link to={"/community/wander_devices"}>
                                <Button text={"Wandering"}
                                        class={loadState === "accutech" ? "nav-link active" : "nav-link"}
                                        onClick={() => setLoadState("accutech")}/>
                            </Link>
                        </li>
                        {iAmHigherAuthority(99, dData?.role_weight)
                            ? <>
                                <li className={"nav-item"}>
                                    <Link to={"/community/system_devices"}>
                                        <Button text={"System Devices"}
                                                class={loadState === "system" ? "nav-link active" : "nav-link"}
                                                onClick={() => setLoadState("system")}/>
                                    </Link>
                                </li>
                                <li className={"nav-item"}>
                                    <Link to={"/community/server_devices"}>
                                        <Button text={"Servers"}
                                                class={loadState === "server" ? "nav-link active" : "nav-link"}
                                                onClick={() => setLoadState("server")}/>
                                    </Link>
                                </li>
                            </>
                            : <></>
                        }
                    </ul>
                    {!pageLoaded
                        ?   skeleton
                        :   <>
                                <div className={"d-flex justify-content-end mb-2"}>
                                    <span className={"text-muted"} style={{fontSize: "var(--font-size-sm)"}}>
                                        Showing <strong>{Math.min(ppRules.start+1, transOrigin.length)}</strong> - <strong>{Math.min(ppRules.end+1, transOrigin.length)}</strong> of <strong>{transOrigin.length}</strong> {transOrigin.length === 1 ? "device" : "devices"}
                                    </span>
                                </div>
                                <table className={"table table-sm table-white table-hover"}>
                                    <thead className={isBannerPresent() ? "sticky-table-headX" : "sticky-table-head"}>
                                    {tableHeaders}
                                    </thead>
                                    <tbody id={"tBody"}>
                                    {tableRows}
                                    </tbody>
                                </table>
                            </>
                    }
                    <div className={"footer-spacer"}>

                    </div>
                </div>
                <Footer center={footer}/>
            </div>
            {/* Floating Help Button - Quarter Circle Corner Shape */}
            <button 
                type={"button"} 
                className={"help-corner-button"}
                onClick={() => showModal("helpmodal")}
                title={"Page Help Popup"}
                aria-label={"Open Help"}
            >
                <i className={"fe fe-help-circle help-corner-button-icon"}></i>
            </button>
            <BulkActionModal start={ppRules.start} end={ppRules.end} header={"Disable Devices"} modalName={"bulkdisablemodal"} closeId={"bulkDisableConfirmClose"}
                             modalContentId={"disableBulkModalContent"} cancelId={"bulkCancelDisable"} spinnerId={"loadBulkDisableSubmit"} submitId={"bulkDisableSubmit"}
                             clickFunction={() => disablePerform("bulkDisableSubmit", "loadBulkDisableSubmit", "bulkDisableConfirmClose", ppRules.start, ppRules.end)} />
            <BulkActionModal start={ppRules.start} end={ppRules.end} header={"Delete Devices"} modalName={"bulkdeletemodal"} closeId={"bulkDeleteConfirmClose"}
                             modalContentId={"deleteBulkModalContent"} cancelId={"bulkCancelDelete"} spinnerId={"loadBulkDeleteSubmit"} submitId={"bulkDeleteSubmit"}
                             clickFunction={() => deletePerform("bulkDeleteSubmit", "loadBulkDeleteSubmit", "bulkDeleteConfirmClose", ppRules.start, ppRules.end)} />
            <PerPageModal filterSubmit={() => filterSubmit()} tmpPerPage={tmpPerPage} setTmpPerPage={(sudocode) => setTmpPerPage(sudocode)} setPage={(sudocode) => setPage(sudocode)}/>
            <input type={"hidden"} id={"dContent"}/>
            <input type={"hidden"} id={"uContent"}/>
            <Suspense fallback={"Loading..."}>
                <ToastContainer position={"bottom-right"} theme={"colored"} newestOnTop={true} pauseOnHover={true}
                                autoClose={10000} closeOnClick={true}/>
            </Suspense>
            <div className={"modal fade help-modal-pop"} id={"helpmodal"} data-bs-backdrop={"static"} data-bs-keyboard={"false"}
                 tabIndex={-1} aria-labelledby={"staticHelpBackdropLabel"} aria-hidden={"true"}>
                <div className={"modal-dialog modal-lg"}>
                    <div className={"modal-content"}>
                        <div className={"modal-header bg-pal"}>
                            <h2 className={"modal-title"} id={"staticHelpBackdropLabel"}>Devices Page Help</h2>
                            <button type={"button"} className={"btn-close"} id={"helpClose"} data-bs-dismiss={"modal"}
                                    aria-label={"Close"}/>
                        </div>
                        <div className={"modal-body"}>
                            <div className={"mb-4"}>
                                <h4 className={"text-primary mb-3"}>
                                    <i className={"fe fe-info me-2"}></i>Getting Started
                                </h4>
                                <p className={"mb-2"}>
                                    The Devices page allows you to view and manage all nurse call devices in your community. 
                                    Use the tabs at the top to switch between different device types.
                                </p>
                            </div>
                            
                            <div className={"mb-4"}>
                                <h5 className={"fw-bold mb-2"}>
                                    <i className={"fe fe-search me-2 text-primary"}></i>Searching and Filtering
                                </h5>
                                <ul className={"list-unstyled ms-4"}>
                                    <li className={"mb-2"}>
                                        <strong>Search Bar:</strong> Use the search bar to quickly find devices by name, description, serial number, model, area, or resident name.
                                    </li>
                                    <li className={"mb-2"}>
                                        <strong>Column Filters:</strong> Click the filter icons in column headers to filter by specific criteria.
                                    </li>
                                    <li className={"mb-2"}>
                                        <strong>Hide Unassigned:</strong> Toggle the "Hide Unassigned" checkbox to show only devices that are assigned to residents or areas.
                                    </li>
                                </ul>
                            </div>

                            <div className={"mb-4"}>
                                <h5 className={"fw-bold mb-2"}>
                                    <i className={"fe fe-smartphone me-2 text-primary"}></i>Device Types
                                </h5>
                                <ul className={"list-unstyled ms-4"}>
                                    <li className={"mb-2"}>
                                        <strong>Nurse Call:</strong> Main tab showing all nurse call devices (Inovonics and PalCare devices).
                                    </li>
                                    <li className={"mb-2"}>
                                        <strong>Wandering:</strong> View and manage wandering prevention devices (Accutech/Roam Alert tag devices).
                                    </li>
                                    {iAmHigherAuthority(80, dData.role_weight)
                                        ?   <><li className={"mb-2"}>
                                                <strong>System Devices:</strong> (Tech only) Network coordinators and repeaters for system infrastructure.
                                            </li>
                                            <li className={"mb-2"}>
                                                <strong>Servers:</strong> (Tech only) Server devices in your system.
                                            </li></>
                                        : <></>
                                    }
                                </ul>
                            </div>

                            {dData.cloud ? <div className={"mb-4"}>
                                <h5 className={"fw-bold mb-2"}>
                                    <i className={"fe fe-activity me-2 text-primary"}></i>Device Health (5.0 Only)
                                </h5>
                                <ul className={"list-unstyled ms-4"}>
                                    <li className={"mb-2"}>
                                        <strong>Battery Status:</strong> Green icon indicates good battery, red icon indicates low battery.
                                    </li>
                                    <li className={"mb-2"}>
                                        <strong>Tamper Status:</strong> Green icon indicates device is secured, red icon indicates device is open/tampered.
                                    </li>
                                    <li className={"mb-2"}>
                                        <strong>Offline Status:</strong> Green icon indicates device is online, red icon indicates device is offline.
                                    </li>
                                    <li className={"mb-2"}>
                                        Monitor device health indicators to ensure devices are functioning properly.
                                    </li>
                                </ul>
                            </div> : <></>}

                            <div className={"mb-4"}>
                                <h5 className={"fw-bold mb-2"}>
                                    <i className={"fe fe-link me-2 text-primary"}></i>Device Assignment
                                </h5>
                                <ul className={"list-unstyled ms-4"}>
                                    <li className={"mb-2"}>
                                        Devices can be assigned to residents or areas.
                                    </li>
                                    <li className={"mb-2"}>
                                        View assigned residents or areas in the respective columns.
                                    </li>
                                    <li className={"mb-2"}>
                                        Click on resident or area names to navigate to their profile pages.
                                    </li>
                                    <li className={"mb-2"}>
                                        Unassigned devices are not actively monitored and may not show accurate health status.
                                    </li>
                                </ul>
                            </div>

                            <div className={"mb-4"}>
                                <h5 className={"fw-bold mb-2"}>
                                    <i className={"fe fe-alert-octagon me-2 text-primary"}></i>Disabling Devices
                                </h5>
                                <ul className={"list-unstyled ms-4"}>
                                    <li className={"mb-2"}>
                                        Select one or more devices using the checkboxes.
                                    </li>
                                    <li className={"mb-2"}>
                                        Click <strong>"Disable"</strong> to deactivate devices and remove them from their assigned resident or area.
                                    </li>
                                    <li className={"mb-2"}>
                                        Disabled devices remain in the system but are marked as inactive.
                                    </li>
                                    <li className={"mb-2"}>
                                        Use this when devices need to be temporarily removed from service.
                                    </li>
                                </ul>
                            </div>

                            {iAmHigherAuthority(80, dData.role_weight)
                                ?   <div className={"mb-4"}>
                                        <h5 className={"fw-bold mb-2"}>
                                            <i className={"fe fe-trash-2 me-2 text-primary"}></i>Deleting Devices
                                        </h5>
                                        <ul className={"list-unstyled ms-4"}>
                                            <li className={"mb-2"}>
                                                Select one or more devices using the checkboxes.
                                            </li>
                                            <li className={"mb-2"}>
                                                Click <strong>"Delete"</strong> to permanently remove devices from the system.
                                            </li>
                                            <li className={"mb-2"}>
                                                <strong>Warning:</strong> This action cannot be undone. Only delete devices that are no longer in use.
                                            </li>
                                            <li className={"mb-2"}>
                                                Deleting a device removes all associated data and history.
                                            </li>
                                        </ul>
                                    </div>
                                : <></>
                            }

                            <div className={"mb-4"}>
                                <h5 className={"fw-bold mb-2"}>
                                    <i className={"fe fe-download me-2 text-primary"}></i>Exporting Data
                                </h5>
                                <ul className={"list-unstyled ms-4"}>
                                    <li className={"mb-2"}>
                                        Click the <strong>"Export"</strong> button to download device data as a CSV file.
                                    </li>
                                    <li className={"mb-2"}>
                                        The export includes device information, assignments, health status, and environmental data.
                                    </li>
                                    <li className={"mb-2"}>
                                        Admin users will see additional fields like Device ID in the export.
                                    </li>
                                </ul>
                            </div>

                            <div className={"mb-3"}>
                                <h5 className={"fw-bold mb-2"}>
                                    <i className={"fe fe-settings me-2 text-primary"}></i>Additional Tips
                                </h5>
                                <ul className={"list-unstyled ms-4"}>
                                    <li className={"mb-2"}>
                                        Click column headers to sort the table by that column.
                                    </li>
                                    <li className={"mb-2"}>
                                        Use the pagination controls at the bottom to navigate through multiple pages.
                                    </li>
                                    <li className={"mb-2"}>
                                        Adjust the number of items per page using the page size button.
                                    </li>
                                    <li className={"mb-2"}>
                                        Click on device names to navigate to their profile pages (for Inovonics and PalCare devices).
                                    </li>
                                    <li className={"mb-2"}>
                                        <strong>Last Alarm:</strong> Shows when the device last triggered an alarm.
                                    </li>
                                    <li className={"mb-2"}>
                                        <strong>Last Active:</strong> Shows when the device last communicated with the system.
                                    </li>
                                    <li className={"mb-2"}>
                                        Regularly check device health indicators to ensure proper system operation.
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className={"modal-footer"}>
                            <button type={"button"} className={"btn btn-secondary"} data-bs-dismiss={"modal"}>Close</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Devices;